// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2r3_T","content":"content-3Nh0N","title":"title-HUG0s","text":"text-22CG4"};